<template>
  <v-content>
    <v-container>
      <v-layout column text-center wrap align-content-center justify-center>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Change your password</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-layout wrap style="width:600px;">
              <v-flex xs12>
                <v-alert v-if="error"
                         border="bottom"
                         colored-border
                         type="error">
                  {{ error }}
                </v-alert>
              </v-flex>
              <v-flex xs12>
                <v-form v-model="valid" ref="form" lazy-validation class="flex-grow-1" autocomplete="on">
                  <v-text-field label="Password"
                                v-model="password"
                                min="8"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                @click:append="showPassword = !showPassword"
                                :type="showPassword ? 'text' : 'password'"
                                :rules="passwordRules"
                                counter
                                required
                                filled></v-text-field>
                  <v-text-field label="Confirm your password"
                                v-model="passwordConfirm"
                                min="8"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                @click:append="showPassword = !showPassword"
                                :type="showPassword ? 'text' : 'password'"
                                :rules="mustMatch"
                                counter
                                required
                                filled></v-text-field>
                  <v-layout justify-space-between>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" @click.prevent="submit" :disabled="!valid" color="primary">Confirm</v-btn>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-progress-linear indeterminate :active="showLoading"></v-progress-linear>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
  import axios from "../plugins/axios";

  export default {
    data() {
      return {
        valid: false,
        showPassword: false,
        password: '',
        passwordConfirm: '',
        passwordRules: [
          v => !!v || 'Password is required',
          v => v.length > 6 || 'Password should be longer than 6 characters'
        ],
        mustMatch: [
          v => v == this.password || "These passwords don't match"
        ],
        error: '',
        showLoading: false,
      }
    },
    methods: {
      submit() {
        if (this.$refs.form.validate()) {
          this.showLoading = true;
          axios.put("api/auth/password", {  password: this.password })
            .then((res) => {
              return this.$store.dispatch("authenticate").then(() => this.$router.go())
            })
            .catch(e => {
              this.showLoading = false;
              if (e && e.response && e.response.data && e.response.data.message)
                this.error = e.response.data.message;
              else
                this.error = "Something went wrong. Please try again later";
            })
        }
      },
      clear() {
        this.$refs.form.reset()
      }
    },
  };
</script>
